export default __webpack_public_path__ + "static/media/expertise.5ffe20a7.mp4";